//#region src/components/Primitives/gridTracks.ts
var e = /^\d*\.?\d+fr$/, t = (t) => {
	let n = [], r = "", i = "", a = () => {
		let t = n.some((e) => e === "minmax" || e === "fit-content");
		r += !t && e.test(i) ? `minmax(0, ${i})` : i, i = "";
	};
	for (let e of t) e === "(" ? (n.push(i.trim().toLowerCase()), r += `${i}(`, i = "") : e === ")" || e === "," || /\s/.test(e) ? (a(), e === ")" && n.pop(), r += e) : i += e;
	return a(), r;
};
//#endregion
export { t as clampFrTracks };
